jQuery(document).ready(function($){
  if (!$('body').hasClass('cart_') || !$('body').hasClass('cart')) {
    if($('.announcement-bar-slider').length > 0){
      $('.announcement-bar-slider .announcement-bar').each(function(k,v){
        const targetDateStr = $(this).find('#countdown-date').data('date');
        const displayTimer = $(this).find('#countdown-date').data('timer-show');
        if(displayTimer == true){
          $(this).find('#announc-id').after(
            `<div class="announcement-bar-timer">
                <div class="clearance_BannerBar_Timmer">
                    <span id="countdownClearance_bar1-${k}" data-date="${targetDateStr}">
                        <span class="ctime eliving-day">
                            <span class="days">00</span> Days
                        </span>:
                        <span class="ctime">
                            <span class="hours">00</span> Hrs
                        </span>:
                        <span class="ctime">
                            <span class="minutes">00</span> Mins
                        </span>:
                        <span class="ctime">
                            <span class="seconds">00</span> Secs
                        </span>
                    </span>
                </div>
            </div>`
          );
           setTimeout(function(){
             if(jQuery('#countdownClearance_bar1-'+k).length > 0){
               // alert('8888888888')
               var date = jQuery('#countdownClearance_bar1-'+k).attr('data-date').replace("-", "/");
               date = date.replace("-","/");
               if(date != '' && date != null && date != 'undefiend'){
                  jQuery('#countdownClearance_bar1-'+k).countdowneliving({
                      date: date+' 23:59:59', 
                      offset: +11.01610, 
                      hideOnComplete: true
                    }, function (container) {
                      //  jQuery('#covid-topbar').hide();
                 });
               }
            } 
          }, 1000)
        }
      
      })
      
    }else{
      const targetDateStr = $('#countdown-date').data('date');
      $('#announc-id').after(
        `<div class="announcement-bar-timer">
            <div class="clearance_BannerBar_Timmer">
                <span id="countdownClearance_bar1" data-date="${targetDateStr}">
                    <span class="ctime eliving-day">
                        <span class="days">00</span> Days
                    </span>:
                    <span class="ctime">
                        <span class="hours">00</span> Hrs
                    </span>:
                    <span class="ctime">
                        <span class="minutes">00</span> Mins
                    </span>:
                    <span class="ctime">
                        <span class="seconds">00</span> Secs
                    </span>
                </span>
            </div>
        </div>`
      );
    }
  }
  
})